<template>
  <div class="news_right">
    <!--轮播图-->
    <div class="news_swiper">
      <swiper :options="newsSwiperOption" :not-next-tick="notNextTick" ref="newsSwiper">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in newsDataSlice" :key="index">
          <div v-if="newsDataSlice.length == 0" class="swiper_bg_img swiper_bg_img_null"></div>
          <router-link :to="{path:'/articleDetail',query: {menuId: item.menuId,plateId:item.plateId,articleId:item.articleId}}" v-else>
            <div class="swiper_bg_img"
                 v-bind:style="{'backgroundImage': `url('${item.imageUrl}')`,backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover' }" @click="goToArticleDetail(item)">
            </div>
          </router-link>

        </swiper-slide>
        <div class="swiper-pagination" id="news-swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!--列表-->
    <ul class="news_list">
      <li v-for="(item,index) in newsData" :key="item.articleId">
        <router-link :to="{path:'/articleDetail',query: {menuId: 29,plateId:curPlateId,articleId:item.articleId}}">
          <span class="news_list_title"><span class="circle"></span>{{item.title}}</span>
          <span class="news_date">{{item.publishTime}}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  import {swiper, swiperSlide} from 'vue-awesome-swiper';
  import newsSwiper from '../assets/images/index/newsSwiper.png'

  export default {
    components: {
      swiper,
      swiperSlide
    },
    props: {
      newsData: Array,// 文章列表
      curPlateId: Number,// 23--工作动态    24--公示公告 menuId--29
    },
    data() {
      return {
        notNextTick: false,
        newsSwiperList: [
          {
            id: 1,
            url: newsSwiper,
          }, {
            id: 2,
            url: newsSwiper,
          }, {
            id: 3,
            url: newsSwiper,
          }, {
            id: 4,
            url: newsSwiper,
          },
        ],
        newsSwiperOption: {
          autoplay: 3000,
          speed: 1000,
          direction: 'horizontal',
          grabCursor: true,
          setWrapperSize: true,
          autoHeight: true,
          pagination: '.swiper-pagination',
          paginationHide:false,
          paginationClickable: true,
          /* prevButton: '.swiper-button-prev',
           nextButton: '.swiper-button-next',*/
//          scrollbar: '.swiper-scrollbar',
          mousewheelControl: false,
          observeParents: true,
          observer: true,
        },
//        showNewsListPagination: true
      }
    },
    computed: {
      newswiper() {
        return this.$refs.newsSwiper.swiper
      },
      //截取文章列表前5个图片---轮播图
      newsDataSlice() {
        let newsData = []
        let temp = this.newsData.map((item) => {
          if (item.imageUrl != '') {
            newsData.push(item)
          }
          return item
        })
        if (newsData.length <= 1) {
          this.newsSwiperOption.paginationHide = true
        }else {
          this.newsSwiperOption.paginationHide = false
        }

        return newsData.length > 5 ? newsData.slice(0, 5) : newsData

      }
    },
    created() {
      /* var newsDataSlice = this.newsData.length > 5 ? this.newsData.slice(0, 5) : this.newsData
       console.log(newsDataSlice)
       console.log(this.newsData)*/

    },
    mounted() {

    },
    methods: {
      goToArticleDetail(item){
        console.log(item)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  // $themeColor: #3e76fc;
  .news_right {
    display: flex;
    .news_swiper {
      width: 454px;
      height: 340px;
      overflow: hidden;
      .swiper_bg_img {
        width: 454px;
        height: 340px;
        transition: transform 0.6s;
      }
      .swiper_bg_img:hover{
        will-change: transform;
        transform:scale(1.3);
      }
      .swiper_bg_img_null {
        background-color: #eff1f4;
      }
    }
    .news_list {
      width: 498px;
      height: 340px;
      background-color: #eff1f4;
      padding: 25px 30px;
      li a {
        height: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        .news_list_title {
          max-width: 300px;
          line-height: 30px;
          color: #2d2d2e;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .circle {
            width: 5px;
            height: 5px;
            display: inline-block;
            border-radius: 50%;
            background-color: $themeColor;
            margin-right: 12px;
          }
        }
        .news_date {
          color: #999;
        }
      }
      li:hover {
        .news_list_title, .news_date {
          color: $themeColor;
        }
      }
    }
  }
</style>
